var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46 10h280v360h-280z",
    fill: "#e2e9ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306 70h-200v360h280v-280z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m336 230h-180c-5.523 0-10-4.477-10-10s4.477-10 10-10h180c5.522 0 10 4.477 10 10s-4.478 10-10 10z",
    fill: "#c5d3de"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m276 270h-120c-5.523 0-10-4.477-10-10s4.477-10 10-10h120c5.522 0 10 4.477 10 10s-4.478 10-10 10z",
    fill: "#c5d3de"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m236 310h-80c-5.523 0-10-4.477-10-10s4.477-10 10-10h80c5.523 0 10 4.477 10 10s-4.477 10-10 10z",
    fill: "#c5d3de"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m206 350h-50c-5.523 0-10-4.477-10-10s4.477-10 10-10h50c5.523 0 10 4.477 10 10s-4.477 10-10 10z",
    fill: "#c5d3de"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m192 170h-36c-5.523 0-10-4.477-10-10s4.477-10 10-10h36c5.523 0 10 4.477 10 10s-4.477 10-10 10z",
    fill: "#a7bdcd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m226 130h-70c-5.523 0-10-4.477-10-10s4.477-10 10-10h70c5.523 0 10 4.477 10 10s-4.477 10-10 10z",
    fill: "#a7bdcd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m306 70v80h80",
    fill: "#e2e9ee"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 392,
    fill: "#ff7d97",
    r: 110
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356 452c-16.569 0-31.569-6.716-42.426-17.574l-35.355 35.355c19.905 19.907 47.405 32.219 77.781 32.219 60.751 0 110-49.249 110-110h-50c0 33.137-26.863 60-60 60z",
    fill: "#7dd9c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356 282v50c33.137 0 60 26.863 60 60h50c0-60.751-49.249-110-110-110z",
    fill: "#ffee80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.957 278.849c.024-.28.043-.562.043-.849v-128c0-2.652-1.054-5.196-2.929-7.071l-57.071-57.072v-75.857c0-5.523-4.478-10-10-10h-280c-5.522 0-10 4.477-10 10v360c0 5.523 4.478 10 10 10h50v50c0 5.523 4.478 10 10 10h140.03c18.554 42.342 60.86 72 109.97 72 66.168 0 120-53.832 120-120 0-52.164-33.461-96.653-80.043-113.151zm-79.957-184.706 45.858 45.857h-45.858zm-260 265.857v-340h260v45.857l-2.929-2.929c-1.876-1.874-4.419-2.928-7.071-2.928h-200c-5.522 0-10 4.477-10 10v290zm60 60v-340h180v70c0 5.523 4.478 10 10 10h70v113.676c-6.507-1.096-13.186-1.676-20-1.676-66.168 0-120 53.832-120 120 0 9.639 1.15 19.013 3.306 28zm240 72c-55.141 0-100-44.86-100-100s44.859-100 100-100 100 44.86 100 100-44.859 100-100 100z",
    fill: "#6d92ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 392,
    fill: "#fff",
    r: 60
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.98132a8d1bf5c1554a5324d3edbbb604.svg";
export { ForwardRef as ReactComponent };